export interface EQDepartment {
  // 부서
  // 상위항목 : EQCompany
  // DB Field
  uid: number | undefined; // 고유값
  companyUID?: number; // 사업체 UID
  name: string; // 부서명

  entryDate?: Date | string; // 등록일
  modifyDate?: Date | string; // 수정일

  isDeleted?: boolean; // 삭제여부

  //NOT DB
  usersCount: number; // 인원 수
}

export const initialDepartmentList: EQDepartment = {
  uid: 0,
  companyUID: 0,
  name: "",
  entryDate: new Date(),
  modifyDate: new Date(),
  isDeleted: false,
  usersCount: 0,
};

export interface DepartmentListParams {
  token: string;
  page: number;
  rows?: number;
}
export const initialDepartmentListParams = {
  page: 1,
  token: "",
  rows: 20,
};
